import { pushToDataLayer } from './datalayer';

// Chrome's native "Translate this page" feature and the Google Translate
// extension both wrap text nodes in extra elements without React's
// knowledge, desyncing the virtual DOM from the real DOM. When React later
// needs to insert/remove a node relative to one of those now-relocated text
// nodes, it throws this exact NotFoundError signature. There is no reliable
// userland fix for the underlying desync (facebook/react#11538, still open
// since 2017), and a React error boundary can't safely recover either: its
// own unmount of the crashed subtree can hit another corrupted node and
// throw again with nothing left to catch it. So this bypasses React
// entirely and writes the recovery message via plain DOM APIs, which can't
// hit the same reconciliation mismatch.
const TRANSLATE_CRASH_PATTERN = /is not a child of this node|Failed to execute '(insertBefore|removeChild)' on 'Node'/;

const isTranslateCrash = (error) => {
    if (!error) return false;
    return error.name === 'NotFoundError' && TRANSLATE_CRASH_PATTERN.test(error.message || '');
};

const showTranslateCrashMessage = () => {
    document.body.innerHTML = `
        <div style="max-width: 480px; margin: 15vh auto; padding: 32px; text-align: center; font-family: sans-serif;">
            <h2>Translation caused a display issue</h2>
            <p>It looks like your browser's translation feature (or the Google Translate extension) is interfering with this page.</p>
            <p>Please turn off page translation for this site, then refresh.</p>
            <button onclick="window.location.reload()" style="margin-top: 16px; padding: 10px 24px; font-size: 16px; cursor: pointer;">Refresh Page</button>
        </div>
    `;
};

export const setupTranslateCrashHandler = () => {
    window.addEventListener('error', (event) => {
        const error = event.error || event;
        const translateCrash = isTranslateCrash(error);

        pushToDataLayer({
            event: 'client_crash',
            error_name: error.name,
            error_message: error.message,
            translate_related: translateCrash
        });

        if (translateCrash) {
            event.preventDefault();
            showTranslateCrashMessage();
        }
    });
};
